import { render } from "./SliderKeyQuestions.vue?vue&type=template&id=ea27814e"
import script from "./SliderKeyQuestions.vue?vue&type=script&lang=js"
export * from "./SliderKeyQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__